import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Image from "@src/components/core-image"
import theme from "@src/styles/theme"

const HeroBox = styled.div`
  background-color: ${props => props.background};
  padding: 40px 32px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lazyload-wrapper {
    margin: auto;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    .hero-image {
      display: none;
      margin-top: 32px;
    }
  }
  @media (max-width: 640px) {
    padding: 24px 24px;
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  gap: 16px;
`

const Subheading = styled.h2`
  color: #fff;
  margin: 0;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  color: ${props =>
    props.color === "light" ? theme.whiteShade : theme.blackShade};
`

export const ParagraphHeroBox = styled.p`
  color: #fff;
  margin: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: ${props =>
    props.color === "light" ? theme.whiteShade : theme.blackShade};

  a {
    color: ${theme.link};
  }
`

const ChildrenWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: max-content;
  max-width: 100%;
  order: ${props => props.order};

  @media (max-width: 600px) {
    width: 100%;
    flex-direction: column;
    gap: 16px;
    .button {
      width: 100%;
    }
    .input {
      width: 100%;
      max-width: 100%;
    }
  }
`

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.size};

  @media (max-width: 1200px) {
    width: 55%;
  }

  @media (max-width: 900px) {
    width: 100%;
  }
`
const Title = styled.h1`
  text-align: center;
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-size: 46px;
  font-style: normal;
  font-weight: 900;
  line-height: 64px;
  letter-spacing: 0.5px;
  margin-bottom: 40px;
  @media (max-width: 400px) {
    font-size: 38px;
    line-height: 56px;
  }
`

const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const ContentHeroBox = ({
  children,
  background = theme.secondary500,
  childrenRight,
  title,
  title2,
  content,
  color = "light",
  image,
  size = "55%",
  childrenPosition = 2,
}) => {
  return (
    <HeroWrapper>
      {title && <Title>{title}</Title>}
      <HeroBox background={background}>
        <LeftSide size={size}>
          <TextContent>
            <Subheading color={color}>{title2}</Subheading>
            {content.map((item, index) => {
              if (typeof item === "string") {
                return (
                  <ParagraphHeroBox key={index} color={color}>
                    {item}
                  </ParagraphHeroBox>
                )
              } else {
                return item
              }
            })}
          </TextContent>
          {children && (
            <ChildrenWrapper order={childrenPosition}>
              {children}
            </ChildrenWrapper>
          )}
        </LeftSide>
        {childrenRight && childrenRight}
        {image && <Image src={image} alt="Hero image" className="hero-image" />}
      </HeroBox>
    </HeroWrapper>
  )
}

ContentHeroBox.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  childrenRight: PropTypes.arrayOf(PropTypes.element),
  background: PropTypes.string,
  title: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ).isRequired,
  image: PropTypes.string.isRequired,
  color: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.string,
  childrenPosition: PropTypes.number,
}

export default ContentHeroBox
